import './style.css'
import ReactDOM from 'react-dom/client'
import { Canvas } from '@react-three/fiber'
import Experience from './Experience.jsx'

const root = ReactDOM.createRoot(document.querySelector('#root'))

root.render(
    <>
        {/* メインサイト(portfolio.pixmichelangelo.com)への戻り導線 */}
        <a className="back-link" href="https://portfolio.pixmichelangelo.com">
            &larr; Pix Michelangelo
        </a>
        <Canvas
            camera={ {
                fov: 45,
                near: 0.1,
                far: 200,
                position: [ 4, - 2, 6 ]
            } }
        >
            <Experience />
        </Canvas>
    </>
)